import styled from "@emotion/styled";

export const NoTrucksMessageContainer = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	display: "flex",
	flexDirection: "column",
	gap: "16px",
	alignItems: "center",
	justifyContent: "center",
	textAlign: "center",
	width: "100%",
	minHeight: "75vh",
	padding: "16px",
	boxSizing: "border-box"
}));

export const NoTrucksTitle = styled.p(({ theme }) => ({
	...theme.project.typography.heading.h6,
	color: theme.project.colors.fontColors.main
}));

export const NoTrucksList = styled.ul(({ theme }) => ({
	...theme.project.typography.body.body1,
	display: "flex",
	flexDirection: "column",
	alignItems: "flex-start",
	justifyContent: "center",
	color: theme.project.colors.fontColors.secondary,
	textAlign: "left",
	padding: 0,
	margin: 0,
	width: "fit-content",
	alignSelf: "center",
	listStylePosition: "inside",
	paddingLeft: "20px",
	"& li:first-of-type": {
		listStyleType: "none",
		marginLeft: "-10px"
	}
}));

export const NoTrucksFooter = styled.p(({ theme }) => ({
	...theme.project.typography.caption,
	color: theme.project.colors.fontColors.secondary
}));
